export const LOGIN_LINK_FRAGMENT_PARAM = 't';
